import { SituacaoSolicitacaoSgsia, SituacaoSolicitacaoEnum } from './situacao-solicitacao-sgsia';
import { EsferasAvaliacaoSgsiaEnum, EsferaAvaliacaoSgsia } from './esfera-avaliacao-sgsia';
import {ProdutoSisbi} from '../sisbi/produto-sisbi';
import {EstabelecimentoSisbi} from '../sisbi/estabelecimento-sisbi';
import {FornecedorSgsia} from './fornecedor-sgsia';

export class SolicitacaoSgsia {
    idSolicitacao: number;
    composicao: string;
    processoFabricacao: string;
    memorialDescritivo: string;
    motivo: string;
    situacaoSolicitacao: any;
    dataSolicitacao: Date;
    fornecedores: Array<FornecedorSgsia>;
    idProdutoSisbi: number;
    produtoSisbi: ProdutoSisbi;
    idEstabelecimentoSisbi: number;
    estabelecimentoSisbi: EstabelecimentoSisbi;
    nrSolicitacao: string;
    cdSeloArte?: string;
    idFiscal?: number;
    nmFiscal?: string;
    dataAnalise?: Date;
    solicitacaoSelo: Array<any>;
    arquivosSolicitacao: Array<any>;
    esferaAvaliacao?: EsferasAvaliacaoSgsiaEnum;
    cdSeloQueijo?: string;
    situacaoSolicitacaoSeloQueijo: any;
    possuiVinculacaoCultural: any;
    utilizaProtocoloFabricacao: any;
    queijariaEmProdutorDeLeite: any;
    utilizaLeiteRastreado: any;
    implementaRastreabilidade: any;
    monitoraSaudeDoManipulador: any;

    /**
     * Converte um objeto json em instancias da classe
     */
    static fromJson(jsonData: any): SolicitacaoSgsia {
        if(!jsonData.situacaoSolicitacaoSeloQueijo){
            jsonData.situacaoSolicitacaoSeloQueijo = SituacaoSolicitacaoEnum.NAO_SOLICITADO;
        }
        if (jsonData.produtoSisbi != null) {
            jsonData.produtoSisbi = ProdutoSisbi.fromJson(jsonData.produtoSisbi);
        }
        if (jsonData.estabelecimentoSisbi != null) {
            jsonData.estabelecimentoSisbi = EstabelecimentoSisbi.fromJson(jsonData.estabelecimentoSisbi);
        }
        if (jsonData.fornecedores != null && jsonData.fornecedores.length > 0) {
            jsonData.fornecedores = jsonData.fornecedores.map(f => FornecedorSgsia.fromJson(f));
        }
        return Object.assign(new SolicitacaoSgsia(), jsonData);
    }

    get situacaoSeloArte() {
        return SituacaoSolicitacaoSgsia.descricaoSituacao(this.situacaoSolicitacao);
    }

    get situacaoSeloQueijo() {
        return SituacaoSolicitacaoSgsia.descricaoSituacao(this.situacaoSolicitacaoSeloQueijo);
    }

    get seloArteSolicitado(){
        return this.situacaoSolicitacao !== SituacaoSolicitacaoEnum.NAO_SOLICITADO;
    }

    get seloQueijoSolicitado(){
        return this.situacaoSolicitacaoSeloQueijo !== SituacaoSolicitacaoEnum.NAO_SOLICITADO;
    }

    //retorna o código sutiação predominante da solicitação
    get codigoSituacaoSelos() {
        if(!this.seloArteSolicitado){
            return this.situacaoSolicitacaoSeloQueijo;
        }
        return this.situacaoSolicitacao;
    }

    //retorna a descrição sutiação predominante da solicitação
    get situacaoSelos() {
        return SituacaoSolicitacaoSgsia.descricaoSituacao(this.codigoSituacaoSelos);
    }

    get nmEsferaAvaliacao(): string {
        return EsferaAvaliacaoSgsia.descricaoEsferaAvaliacao(this.esferaAvaliacao);
    }

}
